module.exports = __webpack_public_path__ + "images/DepositPopup233a246bfa1e242cbafb8cbf4029201d.gif";